import request from '../utils/request';
// url 比后台实际的RequestMapping多一个前缀 (此处多一个recommend)
// 此处多写一个前缀，是因为后台gateway模块拦截到请求会自动截掉第一个前缀
export default {
    query(params) {
      return request({
        url: `/recommend/recommend/query`,
        params,
        method: 'get'
      })
    },
    recommend(body) {
      // return request({
      //   url: `/recommend/recommend/recommend3`,
      //   params,
      //   method: 'post'
      // })
      return request.post(`/recommend/recommend/recommend3`, body)
    },
    plan(params){
      // return request({
      //   url: `/recommend/recommend/plan3`,
      //   params,
      //   method: 'get'
      // })
      return request.post(`/recommend/recommend/plan3`, params)
    }
  }